import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import { Autocomplete, Box, Button, Card, Checkbox, FormControl, FormLabel, Input, Link, Tab, Table, TabList, TabPanel, Tabs, Textarea, Typography } from '@mui/joy';
import { post, Token } from '../../../Script/Session';
import { tabClasses } from '@mui/material';

function BetriebsViewer() {
    const { id } = useParams();
    const [data, setdata] = useState();
    const [wit, setWit] = useState("90.5%");
    const navigate = useNavigate();
    const [perm, setperm] = useState(false);
    const [createmitarbeiter, setcreatemitarbeiter] = useState(false);
    const [users, setusers] = useState([]);
    const [selecteduser, setselecteduser] = useState(null);
    const [createmitarbeiterzuständigkeit, setcreatemitarbeiterzuständigkeit] = useState("");
    const [createnummer, setcreatenummer] = useState(false);
    const [gesellschaften, setgesellschaften] = useState({});
    const [selectedgesellschaft, setselectedgesellschaft] = useState();
    const [inputvermittlernummer, setinputvermittlernummer] = useState("");
    const [keinevereinbarungcheck, setkeinevereinbarungcheck] = useState(false);
    const [vemacheck, setvemacheck] = useState(false);
    const [inputzusatz, setinputzusatz] = useState("");
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get_from_number";
        body.id = Number(id);
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        console.log(response);
        setdata(JSON.parse(response));

        setperm(JSON.parse(response).perm);
        const fetchVereinData = async () => {
            const body = {
                token: Token.get(),
                action: "get_users",
            };

            try {
                let response = await post(body, "/betriebe");
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }
                setusers(JSON.parse(response).users);
                console.log(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        setTimeout(() => {
            fetchVereinData();
        }, 100);


        const fetcha = async () => {

            const body = { token: Token.get(), action: "get" };
            try {
                let response = await post(body, "/gesellschaft");
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }
                setgesellschaften(JSON.parse(response));
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        setTimeout(fetcha, 100);
    }, []);
    function update() {
        let body = {};
        body.token = Token.get();
        body.action = "get_from_number";
        body.id = Number(id);
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setdata(JSON.parse(response));
        console.log(response);
        setperm(JSON.parse(response).perm);
    }

    function addmitarbeiter() {
        if (!selecteduser) {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "add_mitarbeiter";
        body.target = Number(id);
        body.user = selecteduser.id;
        body.aufgabe = createmitarbeiterzuständigkeit;
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        update();
        setcreatemitarbeiter(false);
        setcreatemitarbeiterzuständigkeit("");
    }
    function removemitarbeiter(aid) {
        let body = {};
        body.token = Token.get();
        body.action = "delete_mitarbeiter";
        body.target = Number(id);
        body.user = aid;
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        update();
    }
    function addnummer() {
        let body = {};
        body.token = Token.get();
        body.action = "add_nummer";
        body.target = Number(id);
        body.gesellschaft = selectedgesellschaft.id;
        body.vereinbarungkeine = keinevereinbarungcheck;
        body.vema = vemacheck;
        body.zusatz = inputzusatz;
        body.nummer = Number(1234567890123);
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        update();
        setselectedgesellschaft(null);
    }
    function deletegesellschaft(aid) {
        let body = {};
        body.token = Token.get();
        body.action = "delete_number";
        body.target = Number(id);
        body.gesellschaft = aid;
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        update();
    }
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [adresse, setAdresse] = useState("");
    const [telefon, setTelefon] = useState("");
    const [rechtsform, setRechtsform] = useState("");
    const [hrnummer, setHrnummer] = useState("");
    const [steuernummer, setSteuernummer] = useState(null);
    const [vermoegenshaftpflicht, setVermoegenshaftpflicht] = useState("");
    const [vermoegenshafpflichtsumme, setVermoegenshafpflichtsumme] = useState(null);
    const [vermittlerregnummer, setVermittlerregnummer] = useState("");
    const [finanzanlagenvermittlernummer, setFinanzanlagenvermittlernummer] = useState("");
    const [aufsichtsbehoerde, setAufsichtsbehoerde] = useState("");
    const [verwaltungsprogramm, setVerwaltungsprogramm] = useState("");
    const [huskvergleich, setHuskvergleich] = useState("");
    const [programminvest, setProgramminvest] = useState("");
    const [kvlv, setKvlv] = useState("");
    const [weiteremitgliedschaften, setWeiteremitgliedschaften] = useState("");
    useEffect(() => {
        function a() {
            try {
                setName(data.name);
                setEmail(data.email);
                setWebsite(data.website);
                setAdresse(data.adresse);
                setTelefon(data.tel);
                setRechtsform(data.rechtsform);
                setHrnummer(data.hrnummer);
                setSteuernummer(data.steuer);
                setVermoegenshaftpflicht(data.vermögenhp);
                setVermoegenshafpflichtsumme(data.vermögenhpsum);
                setVermittlerregnummer(data.vermittlernummerreg);
                setFinanzanlagenvermittlernummer(data.finanzvernummer);
                setAufsichtsbehoerde(data.aufsichtbehörde);
                setVerwaltungsprogramm(data.verwaltungsprogramm);
                setHuskvergleich(data.husk);
                setProgramminvest(data.invest);
                setKvlv(data.kvlv);
                setWeiteremitgliedschaften(data.mitgliedschaften);
            } catch {

            }

        }
        setTimeout(() => {
            a();
        }, 550);
    }, [data]);
    function updatedata() {
        let body = {};
        body.token = Token.get();
        body.action = "update";
        body.target = Number(id);
        body.name = name;
        body.email = email;
        body.website = website;
        body.adresse = adresse;
        body.telefon = telefon;
        body.Rechtsform = rechtsform;
        body.hrnummer = hrnummer;
        body.steuernummer = Number(steuernummer);
        body.vermögenshaftpflicht = vermoegenshaftpflicht;
        body.vermögenshafpflichtsumme = Number(vermoegenshafpflichtsumme);
        body.vermittlerregnummer = vermittlerregnummer;
        body.finanzanlagenvermittlernummer = finanzanlagenvermittlernummer;
        body.aufsichtsbehörde = aufsichtsbehoerde;
        body.verwaltungsprogramm = verwaltungsprogramm;
        body.huskvergleich = huskvergleich;
        body.programminvest = programminvest;
        body.kvlv = kvlv;
        body.weiteremitgliedschaften = weiteremitgliedschaften;
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        window.location.reload();

    }
    function deletebetrieb() {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.target = Number(id);
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        navigate("/my-betriebe");
    }
    const [reggroups, setreggroups] = useState();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setreggroups(JSON.parse(response));
    }, []);
    const [vorname, setvorname] = useState();
    const [nachname, setnachname] = useState();
    const [selectedreg, setselectedreg] = useState();
    const [emailput,setemailput] = useState();
    function adduser() {
        if (!selectedreg || !vorname || !nachname || !emailput){
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "add_account";
        body.targetid = Number(id);
        body.email = emailput;
        body.name = vorname;
        body.lastname = nachname;
        body.reggruppe = selectedreg.id;
        let response = post(body, "/betriebe");
        if (response == "LOGOUT"){
            navigate("/");
        }
        update();
        setemailput();
        setselectedreg();
        setnachname();
        setvorname();

    }
    function aktivate(userid) {
        let body = {};
        body.token = Token.get();
        body.action = "lock_account";
        body.targetid = userid;
        body.betriebid = Number(id);
        let response = post(body, "/betriebe");
        if (response == "LOGOUT"){
            navigate("/");
        }
        update();
    }

    return (
        <>
            {
                data && (
                    <Box
                        sx={{
                            width: wit,
                            position: "fixed",
                            top: 0,
                            right: 0,
                            height: "100vh",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            bgcolor: "background.body",
                            borderLeft: "1px solid",
                            borderColor: "divider",
                            overflowY: "auto",
                        }}
                    >

                        <Tabs sx={{ width: "100%" }} defaultValue={0}>
                            <TabList
                                sx={{
                                    pt: 1,
                                    justifyContent: 'center',
                                    [`&& .${tabClasses.root}`]: {
                                        flex: 'initial',
                                        bgcolor: 'transparent',
                                        '&:hover': {
                                            bgcolor: 'transparent',
                                        },
                                        [`&.${tabClasses.selected}`]: {
                                            color: 'primary.plainColor',
                                            '&::after': {
                                                height: 2,
                                                borderTopLeftRadius: 3,
                                                borderTopRightRadius: 3,
                                                bgcolor: 'primary.500',
                                            },
                                        },
                                    },
                                }}
                            >
                                <Tab variant="soft" color="neutral">Allgemein</Tab>
                                <Tab variant="soft" color="neutral">Mitarbeiter</Tab>
                                <Tab variant="soft" color="neutral">Vermittelte Gesellschaten</Tab>
                                {
                                    perm && (
                                        <Tab variant='soft' color='neutral'>
                                            Bearbeiten
                                        </Tab>
                                    )
                                }
                                {
                                    perm && (
                                        <Tab variant='soft' color='neutral'>
                                            Nutzer Hinzufügen
                                        </Tab>
                                    )
                                }
                            </TabList>
                            <TabPanel value={4}>
                                <Card>
                                    <Typography>Nutzer anlegen</Typography>
                                    <Input placeholder='Name' value={vorname} onChange={(e) => setvorname(e.target.value)} />
                                    <Input value={nachname} onChange={(e) => setnachname(e.target.value)} placeholder='Nachname' />
                                    <Input value={emailput} onChange={(e) => setemailput(e.target.value)} placeholder='Email'/>
                                    <Autocomplete onChange={(e, newv) => {
                                        setselectedreg(newv)
                                        console.log(newv);
                                    }

                                    } options={reggroups?.result || []} getOptionLabel={(item) => item.name} placeholder='Regionalgruppe' />
                                    <Button sx={{ width: "10%" }} onClick={() => adduser()}>Erstellen</Button>
                                </Card>
                                <Table>
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            <td>Bearbeiten</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data && data.mitarbeiter.map((item) => {
                                                return (
                                                    <tr>
                                                        <td><Link href={window.location.origin + "/my-profile/"+ item.id}>{item.name}</Link></td>
                                                        <td>{item.locked ? <Button onClick={() => aktivate(item.id)}>Aktivieren</Button> : <Button
                                                        onClick={() => aktivate(item.id)}
                                                        color='danger'>Deaktivieren</Button>}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </TabPanel>
                            <TabPanel value={3}>
                                <Card sx={{ width: "100%", maxWidth: 700, mx: "auto", p: 3 }}>
                                    <Typography level="h4" textAlign="center" mb={2}>
                                        Betrieb bearbeiten
                                    </Typography>

                                    <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                                        <FormControl>
                                            <FormLabel>Name</FormLabel>
                                            <Input value={name} onChange={(e) => setName(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Email</FormLabel>
                                            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Website</FormLabel>
                                            <Input type="url" value={website} onChange={(e) => setWebsite(e.target.value)} />
                                        </FormControl>

                                        <FormControl sx={{ gridColumn: "1 / -1" }}>
                                            <FormLabel>Adresse</FormLabel>
                                            <Textarea minRows={2} value={adresse} onChange={(e) => setAdresse(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Telefon</FormLabel>
                                            <Input type="tel" value={telefon} onChange={(e) => setTelefon(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Rechtsform</FormLabel>
                                            <Input value={rechtsform} onChange={(e) => setRechtsform(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Handelsregisternummer</FormLabel>
                                            <Input value={hrnummer} onChange={(e) => setHrnummer(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Steuernummer</FormLabel>
                                            <Input type="number" value={steuernummer} onChange={(e) => setSteuernummer(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Vermögenshaftpflicht</FormLabel>
                                            <Input value={vermoegenshaftpflicht} onChange={(e) => setVermoegenshaftpflicht(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Haftpflichtsumme</FormLabel>
                                            <Input type="number" value={vermoegenshafpflichtsumme} onChange={(e) => setVermoegenshafpflichtsumme(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Vermittlerregisternummer</FormLabel>
                                            <Input value={vermittlerregnummer} onChange={(e) => setVermittlerregnummer(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Finanzanlagenvermittlernummer</FormLabel>
                                            <Input value={finanzanlagenvermittlernummer} onChange={(e) => setFinanzanlagenvermittlernummer(e.target.value)} />
                                        </FormControl>

                                        <FormControl sx={{ gridColumn: "1 / -1" }}>
                                            <FormLabel>Aufsichtsbehörde</FormLabel>
                                            <Textarea minRows={2} value={aufsichtsbehoerde} onChange={(e) => setAufsichtsbehoerde(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Verwaltungsprogramm</FormLabel>
                                            <Input value={verwaltungsprogramm} onChange={(e) => setVerwaltungsprogramm(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>HUSK-Vergleichsprogramm</FormLabel>
                                            <Input value={huskvergleich} onChange={(e) => setHuskvergleich(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Vergleichsprogramm Invest</FormLabel>
                                            <Input value={programminvest} onChange={(e) => setProgramminvest(e.target.value)} />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Vergleichsprogramm KVL/V</FormLabel>
                                            <Input value={kvlv} onChange={(e) => setKvlv(e.target.value)} />
                                        </FormControl>

                                        <FormControl sx={{ gridColumn: "1 / -1" }}>
                                            <FormLabel>Weitere Mitgliedschaften</FormLabel>
                                            <Textarea minRows={3} value={weiteremitgliedschaften} onChange={(e) => setWeiteremitgliedschaften(e.target.value)} />
                                        </FormControl>
                                    </Box>
                                    <Button onClick={() => updatedata()}>
                                        Speichern
                                    </Button>
                                    <Button onClick={() => deletebetrieb()} sx={{ mt: 3 }} color='danger'>
                                        Betrieb Löschen
                                    </Button>

                                </Card>
                            </TabPanel>
                            <TabPanel value={0}>
                                <Card variant='soft'>

                                    <Typography level="title-md">{data.name}</Typography>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Feld</th>
                                                <th>Eintrag</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Name</td>
                                                <td>{data.name}</td>
                                            </tr>
                                            <tr>
                                                <td>Inhaber</td>
                                                <td><Link href={window.location.origin + "/my-profile/" + data.inhaber.id}>{data.inhaber.name}</Link></td>
                                            </tr>
                                            <tr>
                                                <td>Email</td>
                                                <td>{data.email}</td>
                                            </tr>
                                            <tr>
                                                <td>Telefon</td>
                                                <td>{data.tel}</td>
                                            </tr>
                                            <tr>
                                                <td>Website</td>
                                                <td><Link href={data.website}>{data.website}</Link></td>
                                            </tr>
                                            <tr>
                                                <td>Adresse</td>
                                                <td>{data.adresse}</td>
                                            </tr>
                                            <tr>
                                                <td>Rechtsform</td>
                                                <td>{data.rechtsform}</td>
                                            </tr>
                                            <tr>
                                                <td>Handelsregisternummer</td>
                                                <td>{data.hrnummer}</td>
                                            </tr>
                                            <tr>
                                                <td>Steuernummer</td>
                                                <td>{data.steuer}</td>
                                            </tr>
                                            <tr>
                                                <td>Vermögenshaftpflicht</td>
                                                <td>{data.vermögenhp}</td>
                                            </tr>
                                            <tr>
                                                <td>Vermögenshafpflichtsumme</td>
                                                <td>{data.vermögenhpsum}€</td>
                                            </tr>
                                            <tr>
                                                <td>Vermittlerregisternummer</td>
                                                <td>{data.vermittlernummerreg}</td>
                                            </tr>
                                            <tr>
                                                <td>Finanzanlagenvermittlernummer</td>
                                                <td>{data.finanzvernummer}</td>
                                            </tr>
                                            <tr>
                                                <td>Aufsichtsbehörde</td>
                                                <td>{data.aufsichtbehörde}</td>
                                            </tr>
                                            <tr>
                                                <td>Verwaltungsprogramm</td>
                                                <td>{data.verwaltungsprogramm}</td>
                                            </tr>
                                            <tr>
                                                <td>HUSK-Vergleichsprogramm</td>
                                                <td>{data.husk}</td>
                                            </tr>
                                            <tr>
                                                <td>Vergleichsprogramm Invest</td>
                                                <td>{data.invest}</td>
                                            </tr>
                                            <tr>
                                                <td>Vergleichsprogramm KVL/V</td>
                                                <td>{data.kvlv}</td>
                                            </tr>
                                            <tr>
                                                <td>Weitere Mitgliedschaften</td>
                                                <td>{data.mitgliedschaften}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card>
                            </TabPanel>
                            <TabPanel value={1}>
                                {perm && (
                                    <Card variant='soft'>
                                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                <Typography level="title-md">Mitarbeiter hinzufügen</Typography>
                                                <Typography >fügen sie Mitarbeiter ihres Unternehmens hinzu</Typography>
                                            </Box>
                                            <Button onClick={() => setcreatemitarbeiter(true)} sx={{ height: "5%" }}>
                                                Mitarbeiter hinzufügen
                                            </Button>
                                        </Box>
                                    </Card>
                                )}
                                {createmitarbeiter && (
                                    <Card sx={{ mt: 2 }}>
                                        <Typography level="title-md">Mitarbeiter hinzufügen</Typography>
                                        <Typography mt={-1}>Bitte geben sie alle nötigen Informationen ein</Typography>
                                        <Typography>Nutzer auswählen</Typography>
                                        <Autocomplete
                                            sx={{ width: "35%" }}
                                            options={users}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, newValue) => setselecteduser(newValue)}
                                            value={selecteduser}
                                        />
                                        <Input value={createmitarbeiterzuständigkeit} onChange={(e) => setcreatemitarbeiterzuständigkeit(e.target.value)} placeholder='Tätigkeit' sx={{width: "35%"}}/>
                                        <Button onClick={() => addmitarbeiter()} sx={{ width: "10%" }}>
                                            Speichern
                                        </Button>
                                    </Card>
                                )}

                                {
                                    data && data.mitareiter && data.mitareiter.map((item) => {
                                        return (
                                            <Card sx={{ mt: 2 }}>
                                                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                        <Typography level="title-md"><Link href={window.location.origin + "/my-profile/" + item.id}>{item.name}</Link></Typography>
                                                    </Box>
                                                    {
                                                        data.inhaber.id != item.id && (
                                                            <Button onClick={() => removemitarbeiter(item.id)} color='danger'>
                                                                Entfernen
                                                            </Button>
                                                        )
                                                    }

                                                </Box>

                                                <Table sx={{ '& thead th:nth-child(1)': { width: '15%' } }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Informationen</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Email</td>
                                                            <td>{item.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Tätigkeit</td>
                                                            <td>{item.aufgaben}</td>
                                                        </tr>
                                                    </tbody>


                                                </Table>
                                            </Card>



                                        )




                                    })
                                }
                            </TabPanel>
                            <TabPanel value={2}>
                                {
                                    perm && (
                                        <Card variant='soft'>
                                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography level="title-md">Gesellschaft hinzufügen</Typography>
                                                    <Typography>Drücken sie den Knopf um eine Gesellschaft hinzufügen</Typography>
                                                </Box>
                                                <Button onClick={() => setcreatenummer(true)} sx={{ height: "5%" }}>
                                                    Gesellschaft hinzufügen
                                                </Button>
                                            </Box>
                                        </Card>
                                    )
                                }
                                {
                                    createnummer && (
                                        <Card sx={{ mt: 2 }}>
                                            <Typography level="title-md">Gesellschaft hinzufügen</Typography>
                                            <Typography mt={-1}>Bitte geben sie alle nötigen Informationen ein</Typography>
                                            <Typography>Geben sie die Gesellschaft an</Typography>
                                            <Autocomplete sx={{ width: "35%" }} options={gesellschaften.result} value={selectedgesellschaft} onChange={(e, newv) => setselectedgesellschaft(newv)} getOptionLabel={(item) => item.name} />
                                            <Button onClick={() => addnummer()} sx={{ width: "10%" }}>
                                                Speichern
                                            </Button>
                                        </Card>
                                    )
                                }

                                <Table sx={{ mt: 2 }}>
                                    <thead>
                                        <tr>
                                            <th>Gesellschaft</th>
                                            {
                                                perm && (
                                                    <th>
                                                        Bearbeiten
                                                    </th>
                                                )
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data && data.vermittlernummern.map((item) => {
                                                return (
                                                    <tr key={item.gesellschaftid}>
                                                        <td>{item.gesellschaft}</td>
                                                        {
                                                            perm && (
                                                                <td>
                                                                    <Button onClick={() => deletegesellschaft(item.gesellschaftid)} color='danger'>
                                                                        Löschen
                                                                    </Button>
                                                                </td>
                                                            )
                                                        }
                                                    </tr>
                                                )

                                            })
                                        }
                                    </tbody>
                                </Table>
                            </TabPanel>
                        </Tabs>
                    </Box>
                )
            }
            <NavigationBar state={"profile"} back={true} />
        </>
    )
}

export default BetriebsViewer
